import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { MessageConfirm, clearProcessConfirmData } from '@app/src/views/StepConfirm/sectionConfirm';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';
import { Title } from '@app/src/views/StepConfirm/sectionConfirm';

const isClient = isClientEnv();

export const PaymentPending: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const locationState = location && location.state;
  const urlFromBefore = locationState && locationState.from;
  const confirmData = useSelector(state => state.processConfirm.data);
  const order = useSelector(state => state.processConfirm.data.transactionId);
  const date = useSelector(state => state.processConfirm.data.date);
  const price = useSelector(state => state.processConfirm.data.total);
  const cip = useSelector(state => state.processConfirm.data.cip);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getCategory = () => print && print.general && print.general.category;
  const urlConsume = useSelector(state => state.processConfirm.data.urlConsume);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const typePayment = useSelector(state => state.session.user.pasarella);
  const packageCategory = useSelector(state => state.package.categorySelected);
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    return() => {
      dispatch(clearProcessConfirmData());
    }
  }, []);

  useEffect(() => {
    if (typePayment && confirmData && Object.keys(confirmData).length > 0) {
      if (urlFromBefore === 'purchase-print') {
        pushDatalayer(CATEGORIES[CATEGORY[getCategory()]].name);
        setTheme(CATEGORIES[CATEGORY[getCategory()]]);
      }
      if (typePayment === 'purchase-package') {
        pushDatalayerPackage(CATEGORIES[CATEGORY[packageCategory]].name);
        setTheme(CATEGORIES[CATEGORY[packageCategory]]);
      }
    } else {
      history.push('/');
    }
  }, [typePayment, confirmData]);

  const pushDatalayer = (categoryName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': `Confirmación de Pago - ${categoryName} - PE`,
        'eventAction': `Paso 4 - ${categoryName}`,
        'eventLabel': `${order}|${date}|S/ ${price}`,
        'eventValue': 1
      })
    }
  };

  const pushDatalayerPackage = (categoryName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EvPasosdecompra',
        'category': `P3_${categoryName}`,
        'action': `${userStorage && userStorage.titleLayer}_${userStorage && userStorage.facture}_PE`,
        'label': userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id,
        'value': price
      })
    }
  };

  const setMessage = (type) => {
    if (type === 'purchase-package') {
      return 'Te hemos enviado un correo con el detalle de tu compra';
    }
    if (type === 'purchase-print') {
      return 'Recuerda que la publicación de tu aviso impreso está sujeto al pago antes de la fecha de cierre de publicación de la edición seleccionada.'
    }
  };

  const setRedirect = () => {
    if (typePayment === 'purchase-package') {
      return urlConsume || '/';
    }
    if (typePayment === 'consume-print') {
      return urlConsume;
    }
    if (urlFromBefore === 'purchase-print') {
      return theme.paths.purchasePrint.stepOne;
    }
  };

  const handleClickNext = () => {
    const urlNext = setRedirect();
    if (isClient) {
      sessionStorage.removeItem('print');
      sessionStorage.removeItem('printWeb');
      window.location.href = urlNext;
    }
  };

  return (
    Object.keys(confirmData).length > 0 && <MessageConfirm
      message={setMessage(urlFromBefore)}
      buttonText="Crear nuevo aviso"
      theme={COLORS.BLACK_BOLD}
      handleClickNext={handleClickNext}
      details={[
        {
          description: 'Código de pago CIP',
          value: cip
        },
        {
          description: 'Número de orden',
          value: order
        },
        {
          description: 'Fecha de expiración',
          value: date
        },
        {
          description: 'Total',
          value: price
        }
      ]}
    >
      { }
      <Title
        imgSrc={theme && theme.successImage}
        text="Tu compra se encuentra pendiente de pago"
      />
    </MessageConfirm>
  )
};
